// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BJTC","importantInfo":"styles_importantInfo__1rX8z"};